import React from 'react'
import { Wrench } from 'phosphor-react'
import styled from 'styled-components'
import { PRIORITY_COLORS, isMaintenanceTask, priorityName } from './maintenance-utils'

const Chip = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 4px;
    padding: 2px 8px;
    border: 1px solid #99d5cf;
    border-radius: 10px;
    background: #ecfdf9;
    color: #0f766e;
    font-size: 11px;
    line-height: 16px;
    cursor: pointer;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .priority {
        font-weight: 600;
    }
`

/** Task list badge for maintenance tasks (EAUDITOR-407): "Maintenance · <asset> · <priority>", opens the detail. */
export const MaintenanceTaskChip = ({ task, onOpen }) => {
    if (!isMaintenanceTask(task)) return null
    const priority = Number(task.MaintenancePriorityId) || 2
    // stages worth seeing on the list: 2 pre-inspection open, 5 waiting for the verification inspection
    const stageText = { 2: 'Pre-inspection', 5: 'Awaiting verification' }[Number(task.MaintenanceStage)]
    const parts = [task.MaintenanceTypeName || 'Maintenance', task.AssetName, stageText].filter(Boolean)
    return (
        <Chip
            type="button"
            title="Open the maintenance task"
            onClick={e => {
                e.stopPropagation()
                if (onOpen) onOpen(task.TaskId)
            }}
        >
            <Wrench size={12} weight="bold" />
            <span>{parts.join(' · ')}</span>
            {priority >= 3 && (
                <span className="priority" style={{ color: PRIORITY_COLORS[priority] }}>
                    · {priorityName(priority)}
                </span>
            )}
        </Chip>
    )
}
